import { render, staticRenderFns } from "./Telegram.vue?vue&type=template&id=a04980ea&scoped=true&"
import script from "./Telegram.js?vue&type=script&lang=js&"
export * from "./Telegram.js?vue&type=script&lang=js&"
import style0 from "./Telegram.vue?vue&type=style&index=0&id=a04980ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04980ea",
  null
  
)

export default component.exports